'use client'

import { inputFocusClasses } from '../ui/input'
import { XIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DrawerClose,
  DrawerContent,
  Drawer as DrawerRoot,
  DrawerTitle,
} from '@/components/ui/drawer'
import { cn } from '@/utilities/ui'

export const Drawer: React.FC<{
  children: React.ReactNode
  ariaTitle?: string
  open: boolean
  setOpen(open: boolean): void
  onAnimationEnd?: (open: boolean) => void
  className?: string
  fullWidth?: boolean
  size?: 'default' | 'small'
}> = ({
  children,
  ariaTitle = 'Drawer',
  open,
  setOpen,
  onAnimationEnd,
  className,
  fullWidth = false,
  size = 'default',
}) => {
  return (
    <DrawerRoot
      open={open}
      onOpenChange={setOpen}
      onAnimationEnd={onAnimationEnd}
      direction="right"
      handleOnly
      modal={true}
    >
      <DrawerContent
        className={cn(
          'my-2 h-[calc(100svh-1rem-env(safe-area-inset-bottom))] w-screen max-w-[calc(100vw-1rem)] rounded-xl border-none bg-white p-0 shadow-[0_0_20px_rgba(0,0,0,0.25)]',
          inputFocusClasses,
          fullWidth
            ? 'data-[vaul-drawer-direction=right]:sm:w-[calc(100vw-1rem)] data-[vaul-drawer-direction=right]:sm:max-w-[calc(100vw-1rem)]'
            : size === 'small'
              ? 'xs:max-w-6xl!'
              : 'xs:max-w-3/4',
          className,
        )}
      >
        <div className="relative flex size-full flex-col gap-4 p-3">
          <DrawerTitle className="sr-only">{ariaTitle}</DrawerTitle>
          <div
            className={cn(
              'flex min-h-0 flex-col overflow-y-auto',
              inputFocusClasses,
              size === 'small' && !fullWidth && 'relative',
            )}
            data-lenis-prevent
          >
            <div
              className={cn(
                'sticky top-0 z-10 flex shrink-0 justify-end',
                size === 'small' && !fullWidth && 'h-0',
              )}
            >
              {size === 'small' && !fullWidth ? (
                <div className="size-12 bg-background pt-[3px] pr-[3px] pb-2 pl-2">
                  <DrawerClose asChild>
                    <Button
                      variant="icon"
                      customIcon={<XIcon className="size-4" />}
                      aria-label="Close menu"
                    />
                  </DrawerClose>
                </div>
              ) : (
                <div className="pt-[3px] pr-[3px] pb-2 pl-2">
                  <DrawerClose asChild>
                    <Button
                      variant="icon"
                      customIcon={<XIcon className="size-4" />}
                      aria-label="Close menu"
                    />
                  </DrawerClose>
                </div>
              )}
            </div>
            <div className="mt-3 flex min-h-0 flex-1 flex-col gap-2">{children}</div>
          </div>
        </div>
      </DrawerContent>
    </DrawerRoot>
  )
}
